import {
INQUIRY_SHIPPER_GET_ALL_INQUIRIES,
INQUIRY_SHIPPER_GET_STATUS_WISE_COUNT,
INQUIRY_SHIPPER_GET_ALL_INQUIRIES_ENABLE_LOADING,
INQUIRY_SHIPPER_GET_ALL_INQUIRIES_DISABLE_LOADING,
INQUIRY_SHIPPER_GET_ALL_INQUIRIES_FETCH_ERROR,
INQUIRY_SHIPPER_GET_ALL_INQUIRIES_SET_FILTERS,
INQUIRY_SHIPPER_GET_ALL_INQUIRIES_APPLY_FILTERS,
INQUIRY_SHIPPER_GET_ALL_INQUIRIES_SET_PAGINATION,
INQUIRY_SHIPPER_GET_ALL_INQUIRIES_RESET_FILTERS,
INQUIRY_SHIPPER_GET_ALL_INQUIRIES_RESET_PAGINATION,
INQUIRY_SHIPPER_GET_INQUIRY_DETAIL_ENABLE_LOADING,
INQUIRY_SHIPPER_GET_INQUIRY_DETAIL_DISABLE_LOADING,
INQUIRY_SHIPPER_SEARCH_ENABLE_LOADING,
INQUIRY_SHIPPER_SEARCH_DISABLE_LOADING,
INQUIRY_SHIPPER_SEARCH_SET_DATA,
INQUIRY_SHIPPER_SEARCH_ERROR,
INQUIRY_SHIPPER_INQUIRY_DETAIL_FETCH_ERROR,
INQUIRY_SHIPPER_SET_INQUIRY_DETAIL_DATA,
INQUIRY_SHIPPER_SET_INQUIRY_ID_FOR_DETAIL,
INQUIRY_SHIPPER_GET_ALL_INQUIRIES_SET_PREV_PAGINATION,
SET_CREATE_INQUIRY_DATA,
INQUIRY_SHIPPER_BIDS_RANKING_DATA,
INQUIRY_SHIPPER_BIDS_RANKING_DATA_IS_LOADING,
INQUIRY_SHIPPER_BOOKING_STAT_COUNTS_DATA,
INQUIRY_SHIPPER_BOOKING_STAT_COUNTS_DATA_IS_LOADING,
BULK_INQUIRY_CHECK_CHANGED,
} from 'src/actions/constants';

const defaultState = {
  isLoading: false,
  selectedFilters: {
    status: 'ALL',
    sortBy: 'created_at',
    descendingOrder: true,
    polList: [],
    podList: [],
    typeList: [],
    modeList: [],
    polSearch: 'port',
    podSearch: 'port',
    inquiriesCreatedBy: undefined,
    userIdList: [],
    originCityList: [],
    destinationCityList: [],
    originCountryList: [],
    destinationCountryList: [],
    customerIds: [],
    shipperIds: [],
    supplierIds: [],
  },
  appliedFilters: {
    sortBy: 'created_at',
    descendingOrder: true,
    status: 'ALL',
    polList:[],
    podList:[],
    typeList:[],
    modeList: [],
    originCityList: [],
    destinationCityList: [],
    originCountryList: [],
    destinationCountryList: [],
    customerIds: [],
    shipperIds: [],
    supplierIds: [],
  },
  pagination: {
    currentPageNumber: 1,
    resultPerPage: 10,
    nextOrPrev: 'first',
  },
  prevPagination : {
    currentPageNumber: 1,
    resultPerPage: 10,
    nextOrPrev: 'first',
  },
  inquiryDetailLoading: false,
  createInquiryData: {},
  refrenceNumber: [],
  inquiryId: [],
  allInquiries: [],
  selectedInquiryID:'',
  shipperInquiryDetail:{},
  inquiryShipperBidsRankingData: {},
  isLoadingInquiryShipperBidsRankingData: false,
  inquiryShipperBookingStatCountsData: {},
  isLoadingInquiryShipperBookingStatCountsData: false,
  selectedItems: {},
};

export default function (state: typeof defaultState = defaultState, action) {
  switch (action.type) {
    case INQUIRY_SHIPPER_BOOKING_STAT_COUNTS_DATA: {
      return {
        ...state,
        inquiryShipperBookingStatCountsData: action.data,
      }
    }

    case INQUIRY_SHIPPER_BOOKING_STAT_COUNTS_DATA_IS_LOADING: {
      return {
        ...state,
        isLoadingInquiryShipperBookingStatCountsData: action.data,
      }
    }
    
    case INQUIRY_SHIPPER_BIDS_RANKING_DATA: {
      return {
        ...state,
        inquiryShipperBidsRankingData: action.data,
      }
    }

    case INQUIRY_SHIPPER_BIDS_RANKING_DATA_IS_LOADING: {
      return {
        ...state,
        isLoadingInquiryShipperBidsRankingData: action.data,
      }
    }

    case INQUIRY_SHIPPER_SEARCH_ENABLE_LOADING: {
      return {
        ...state,
        isSearching: true,
      };
    }
    case INQUIRY_SHIPPER_SEARCH_DISABLE_LOADING: {
      return {
        ...state,
        isSearching: false,
      };
    }

    case INQUIRY_SHIPPER_SET_INQUIRY_ID_FOR_DETAIL: {
      return {
        ...state,
        selectedInquiryID: action.data,
      };
    }

    case INQUIRY_SHIPPER_SEARCH_SET_DATA: {
      return {
        ...state,
        inquiryId: action.data.inquiryId,
        refrenceNumber: action.data.refrenceNumber,
      };
    }

    case INQUIRY_SHIPPER_SEARCH_ERROR: {
      return {
        ...state,
        errorMessage : action.data,
      };
    }

    case INQUIRY_SHIPPER_GET_ALL_INQUIRIES_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case INQUIRY_SHIPPER_GET_INQUIRY_DETAIL_ENABLE_LOADING: {
      return {
        ...state,
        inquiryDetailLoading:true,
      };
    }

    case INQUIRY_SHIPPER_GET_INQUIRY_DETAIL_DISABLE_LOADING: {
      return {
        ...state,
        inquiryDetailLoading: false,
      };
    }

    case INQUIRY_SHIPPER_GET_ALL_INQUIRIES_SET_FILTERS : {
      return {
        ...state,
        selectedFilters :{
          ...state.selectedFilters,
          ...action.data,
        },
      };
    }

    case INQUIRY_SHIPPER_GET_ALL_INQUIRIES_APPLY_FILTERS : {
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          ...state.selectedFilters,
        },
      };

    }

    case INQUIRY_SHIPPER_GET_ALL_INQUIRIES_SET_PAGINATION : {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.data,
        },
      };
    }
    case INQUIRY_SHIPPER_GET_ALL_INQUIRIES_DISABLE_LOADING : {
      return {
        ...state,
        isLoading : false,
      };
    }

    case INQUIRY_SHIPPER_GET_ALL_INQUIRIES_RESET_FILTERS: {
      return {
        ...state,
        appliedFilters: defaultState.appliedFilters,
        selectedFilters: defaultState.selectedFilters,
      };
    }

    case INQUIRY_SHIPPER_GET_ALL_INQUIRIES_RESET_PAGINATION: {
      return {
        ...state,
        pagination: {
          currentPageNumber : 1,
          nextOrPrev: 'first',
          resultPerPage: state.pagination.resultPerPage,
        },
      };
    }
    case INQUIRY_SHIPPER_GET_ALL_INQUIRIES_SET_PREV_PAGINATION: {
      return {
        ...state,
        pagination: state.prevPagination,
      };
    }

    case INQUIRY_SHIPPER_GET_ALL_INQUIRIES : {
      return {
        ...state,
        allInquiries : action.data ? action.data.data : [],
        prevPagination : {
          ...state.pagination,
        },
        pagination : {
          ...state.pagination,
          currentPageNumber: action.data && action.data.currentPageNumber ||
            state.pagination.currentPageNumber,
          lastSortedColumnValueNext: action.data && action.data.lastSortedColumnValueNext,
          lastSortedColumnValuePrev: action.data && action.data.lastSortedColumnValuePrev,
          lastItemIdNext: action.data && action.data.lastItemIdNext,
          lastItemIdPrev: action.data && action.data.lastItemIdPrev,
          isNextPresent: action.data && action.data.isNextPresent,
          nextOrPrev: action.data && action.data.nextOrPrev,
        },
      };
    }

    case INQUIRY_SHIPPER_GET_STATUS_WISE_COUNT: {
      return {
        ...state,
        statusWiseInquiryCount: action.data,
      };
    }

    case INQUIRY_SHIPPER_GET_ALL_INQUIRIES_FETCH_ERROR : {
      return {
        ...state,
        errorMessage : action.data,
      };
    }

    case INQUIRY_SHIPPER_SET_INQUIRY_DETAIL_DATA : {
      return {
        ...state,
        shipperInquiryDetail : action.data,
      };
    }

    case SET_CREATE_INQUIRY_DATA : {
      return {
        ...state,
        createInquiryData :{
          ...state.createInquiryData,
          ...action.data,
        },
      };
    }

    case INQUIRY_SHIPPER_INQUIRY_DETAIL_FETCH_ERROR : {
      return {
        ...state,
        errorMessage : action.data,
      };
    }
    
    case BULK_INQUIRY_CHECK_CHANGED : {
      return {
        ...state,
        selectedItems : action.data,
      }
    }
    
    default: return state;

  }
}
